
import React from "react";
import { BrowserRouter } from 'react-router-dom';
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import FloatingButtons from "./components/FloatingActions/FloatingActions";
import AppRoutes from "./routes/AppRoutes";
import ScrollTop from "./components/ScrollTop/ScrollTop";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <AppRoutes />
      <FloatingButtons />
      <ScrollTop />
      <Footer />
    </BrowserRouter>
  );
}
